var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-custom-scrollbar',{ref:"PageScroll",staticClass:"scroll-area",attrs:{"settings":_vm.settings}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }